import React, { useState } from "react";

import { Box, useColorModeValue, useDisclosure } from "@chakra-ui/react";

import ProspectHeader from "../../Components/ProspectHeader";

import ProspectTable from "../../Components/Tables/ProspectTable";

import AddProspect from "../../Components/Drawers/AddProspect";
import EditProspect from "../../Components/Drawers/EditProspect";

import BulkProspectModal from "../../Components/Modals/BulkProspectModal";
import DeleteModal from "../../Components/Modals/DeleteModal";

import Header from "../../Components/Header";

const Prospects = () => {
  const [loading, setLoading] = useState(true);

  const {
    isOpen: addOpen,
    onOpen: addOnOpen,
    onClose: addOnClose,
  } = useDisclosure();

  const {
    isOpen: editOpen,
    onOpen: editOnOpen,
    onClose: editOnClose,
  } = useDisclosure();

  const {
    isOpen: bulkAddOpen,
    onOpen: bulkAddOnOpen,
    onClose: bulkAddOnClose,
  } = useDisclosure();

  const {
    isOpen: deleteOpen,
    onOpen: deleteOnOpen,
    onClose: deleteOnClose,
  } = useDisclosure();

  // const { isOpen, onOpen, onClose } = useDisclosure();

  const bgColor = useColorModeValue("white.primary", "blue.primary");

  return (
    <Box
      w={{ xl: "85%", lg: "85%", md: "100%", sm: "100%" }}
      height="100%"
      bg={bgColor}
      px="5"
      position="relative"
    >
      <Header />
      {/* Table */}
      <ProspectTable
        delOpen={deleteOnOpen}
        onOpen={editOnOpen}
        addOnOpen={addOnOpen}
        onBulkOpen={bulkAddOnOpen}
      />
      <AddProspect isOpen={addOpen} onOpen={addOnOpen} onClose={addOnClose} />
      <EditProspect
        isOpen={editOpen}
        onOpen={editOnOpen}
        onClose={editOnClose}
      />
      <BulkProspectModal
        isOpen={bulkAddOpen}
        onOpen={bulkAddOnOpen}
        onClose={bulkAddOnClose}
      />
      <DeleteModal
        isOpen={deleteOpen}
        onOpen={deleteOnOpen}
        onClose={deleteOnClose}
        text="prospect"
      />
    </Box>
  );
};

export default React.memo(Prospects);
